// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"news_wrapper__t2yUy","titleWrap":"news_titleWrap__NDGEf"};